import { Table as _Table, TableProps as _TableProps } from "reactstrap";

export const Table = _Table;
export type TableProps = _TableProps;
